<template>
  <el-container class="btc-main">
    <el-header>
      <Header></Header>
    </el-header>
    <el-main class="btc-column-main">
        <!-- 面包屑 -->
        <!-- <BreadCrumb/> -->
        <router-view ref="btc_main"></router-view>
    </el-main>
    <!-- <Footer :class="footFlag"></Footer> -->
</el-container>
</template>

<script>
/* eslint-disable */
import Header from '@/components/header/Header.vue';
import Footer from "@/components/Footer/New-footer.vue";
import BreadCrumb from "@/components/global/My-breadcrumb.vue";

export default {
  name: 'home',
  components: {
    Header,
    Footer,
    BreadCrumb
  },
  data: function () {
    return {
        footFlag: ''
    }
  },
  created() {
    // this.$store.dispatch('getUserPermission')
  },
  mounted() {
      this.footHandle();
  },
  watch: {
      $route: function () {
          this.footHandle();
      }
  },
  methods: {
    footHandle() {// 判断底部条位置
        var that = this;
        setTimeout(function () {
          let content_node = that.$refs.btc_main;
          let content_height = content_node.$el.offsetHeight;
          let screen_height = window.innerHeight;

          if (content_height < (screen_height-90)) {
              that.footFlag = 'fixed_bottom';
          } else {
              that.footFlag = '';
              content_node.$el.classList.remove('fixed_bottom');
          }
        }, 200)
    }
  }
}
</script>

<style lang="scss">
.btc-main {
  > .el-main {
      padding: 15px 0;
      background-color: #252425;
      // width: 1300px;
  }
  .el-header {
    width: 100%;
    background-color: #1e1e1e;
  }
  .btc-column-main {
    margin: 0 10px;
  }
}

@media screen and (max-width: 1700px) {
  .btc-main {
    .btc-column-main {
      width: 1300px;
      margin: auto;

      .unilateral-static{
        width: 1300px;
      }
    }

    .footer {
      > .name {
        width: 1300px;
        margin: auto;
        background-color: #000000;
      }
    }
  }
}
</style>